import type { AuditLog } from '~features/audit-logs/api/get-audit-logs';

import type {
  AuditEventBadgeVariant,
  AuditLogActorDisplay,
} from './audit-logs.types';

export function formatAuditValue(value: string): string {
  try {
    return value
      .split(/[-_]/g)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  } catch (error) {
    console.error('Failed to format audit value', { error });
    throw error;
  }
}

export function resolveAuditLogTitle(log: AuditLog): string {
  try {
    const resourceType = log.resourceType?.toLowerCase();
    if (resourceType === 'enrollment') {
      return log.enrollmentDisplayName || log.resourceName;
    }
    if (resourceType === 'payment') {
      return log.paymentDisplayName || log.resourceName;
    }
    return log.resourceName;
  } catch (error) {
    console.error('Failed to resolve audit log title', { error });
    throw error;
  }
}

export function resolveAuditLogActor(log: AuditLog): AuditLogActorDisplay {
  try {
    const actorNameTrim = log.actorName?.trim();
    const parentNameTrim = log.parentActorDisplayName?.trim();
    const actorEmailTrim = log.actorEmail?.trim();
    const parentEmailTrim = log.parentActorEmail?.trim();

    const displayName =
      actorNameTrim ||
      parentNameTrim ||
      actorEmailTrim ||
      parentEmailTrim ||
      'Portal User';

    const lineIsEmailOnly =
      displayName === actorEmailTrim || displayName === parentEmailTrim;

    return {
      displayName,
      subEmail: lineIsEmailOnly
        ? '—'
        : actorEmailTrim || parentEmailTrim || '—',
    };
  } catch (error) {
    console.error('Failed to resolve audit log actor', { error });
    throw error;
  }
}

export function getAuditEventBadgeVariant(
  eventType: string,
): AuditEventBadgeVariant {
  try {
    const eventTypeLower = eventType.toLowerCase();
    if (eventTypeLower === 'created') {
      return 'default';
    }
    if (eventTypeLower === 'deleted') {
      return 'destructive';
    }
    if (eventTypeLower === 'updated') {
      return 'secondary';
    }
    return 'outline';
  } catch (error) {
    console.error('Failed to resolve audit event badge', { error });
    throw error;
  }
}
